import _ from 'lodash';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MdbModalWrapperService } from 'app/core/services/mdb-modal-wrapper.service';
import { P2pMoveTransactionsModalComponent } from 'app/manage-p2p/modals/p2p-move-transactions-modal/p2p-move-transactions-modal.component';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class ModalP2pMoveTransactionsService {
  public modalRef: MdbModalRef<any> | null = null;

  constructor(
    private http: HttpClient,
    private modalService: MdbModalWrapperService,
    private cookieService: CookieService
  ) { }

  open(data) {
    if(this.modalRef) {
      return this.modalRef;
    }

    this.modalRef = this.modalService.open(P2pMoveTransactionsModalComponent, {
      ignoreBackdropClick: false,
      containerClass:'mdb-modal-backdrop-paybee modal fade show',
      modalClass:'modal-dialog modal-lg',
      data: {data}
    });    

    return this.modalRef;
  }

  close() {
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }

  addCommasToNumber(number) {
    return window['utils'].getAmountDisplay(number);
  }

  moveTransactions({transactionIds,moveFromP2PId,moveToP2PId,campaignId}){

    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({
        "moveFromP2PId": moveFromP2PId,
        "moveToP2PId"  : moveToP2PId,
        "transactionIds": transactionIds,
        "campaignId": campaignId,
      }))}`
    ];

    return this.http.post('/api/p2p/transactions/move', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }
}
